import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  radioButton: (props) => ({
    display: 'inline-flex',
    alignItems: 'center',
    flexDirection: props.orientation === 'vertical' ? 'column' : 'row',
    cursor: 'pointer',

    '& > .mainRadio': {
      display: 'none',
    },

    '&.disabled': {
      filter: 'opacity(0.6)',
      cursor: 'not-allowed',
    },

    '& > .label': {
      display: 'inline-flex',
      verticalAlign: 'middle',
    },
  }),
});

export default useStyle;
